import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsIconAllocationMutation() {
  return useMutation({
    mutationFn: async ({ iconAllocationParams, projectId }) => {
      const response = await axios.post(
        `/projects/${projectId}/icon_allocations`,
        { icon_allocation: iconAllocationParams },
      );

      return response.data;
    },
  });
}

export function useDestroyProjectsIconAllocationMutation() {
  return useMutation({
    mutationFn: async ({ id, projectId }) => {
      const response = await axios.delete(
        `/projects/${projectId}/icon_allocations/${id}`,
      );

      return response.data;
    },
  });
}
